export enum Actions {
  NOTES = 'Notes',
  ORDER_NOTE = 'Order Note',
  MoreInfo = 'More Info',
}
